/**
 * Precision Tabs Component
 * Handles section migration and tab functionality
 * Can be used by any section that needs tab functionality
 */

export function migrateSection() {
  const sections = document.querySelectorAll('[data-migrate-section]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.migrateSection;
    if (sectionId) {
      const query = `[data-section-target="${sectionId}"]`;
      const targetSection = document.querySelector(query);
      
      if (targetSection) {
        targetSection.innerHTML = section.innerHTML;
        section.remove();
      }
    }
  });
}

export function initTabFunctionality() {
  const tabLists = document.querySelectorAll('[data-tab-list]');
  tabLists.forEach(list => {
    if (list.dataset._tabAttached) return;
    list.dataset._tabAttached = true;
    
    const isTabSlide = list.hasAttribute('data-tab-slide');
    const tabs = list.querySelectorAll('[data-tab]');
    
    tabs.forEach((tab, index) => {
      const panelId = tab.dataset.tabTarget;
      const panel = document.getElementById(panelId);
      
      if (!panel) return;
      
      tab.addEventListener('click', () => {
        // Update all tabs
        tabs.forEach((t) => {
          t.setAttribute('aria-selected', 'false');
          t.classList.remove('active');
          const tabsParent = list.closest('[data-tabs-section]');
          const allPanels = tabsParent.querySelectorAll(`[data-tab-content]`);
          allPanels.forEach(p => {
            p.classList.add('tw-hidden');
            p.classList.remove('tw-block');
          });
        });
        
        // Set active tab
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        
        // Show panel with matching tab_id
        panel.classList.remove('tw-hidden');
        panel.classList.add('tw-block');
        
        // Handle Swiper slide if in carousel
        const swiperEl = tab.closest('carousel-swiper');
        if (swiperEl && isTabSlide && swiperEl.swiper) {
          swiperEl.swiper.slideTo(index);
        }
      });
      
      // Keyboard navigation
      tab.addEventListener('keydown', e => {
        let newIndex = index;
        if (e.key === 'ArrowRight') newIndex++;
        else if (e.key === 'ArrowLeft') newIndex--;
        
        if (newIndex < 0) newIndex = tabs.length - 1;
        if (newIndex >= tabs.length) newIndex = 0;
        
        tabs[newIndex].focus();
        tabs[newIndex].click();
      });
    });
  });
}

export function initPrecisionTabs() {
  initTabFunctionality();
}

